<div class="field-dialog">
  <mat-toolbar class="field-dialog__header">
    <div class="field-dialog__header__title">
      <h2 class="field-dialog__header__title__text">
        {{
          'COMPANY_COMPARISON.CHOOSE_COMPANIES' | translate: { quantity: selectedCompaniesSelection.selected.length }
        }}
      </h2>
    </div>

    <button class="field-dialog__header__close" mat-icon-button (click)="matDialogRef.close()">
      <mat-icon class="field-dialog__header__close__icon">close</mat-icon>
    </button>
  </mat-toolbar>

  <div class="field-dialog__content">
    <form #content class="field-dialog__content__scroll" name="form" fusePerfectScrollbar>
      <div (click)="input.focus()" class="field-dialog__content__scroll__search">
        <mat-icon class="field-dialog__content__scroll__search__icon">search</mat-icon>
        <input
          #input
          [formControl]="searchTerm"
          class="field-dialog__content__scroll__search__input"
          [placeholder]="'COMPANY_COMPARISON.DIALOG.SEARCH_BY_NAME' | translate"
        />
      </div>

      <div *ngIf="selectedCompanies.length" class="field-dialog__content__scroll__selected-companies">
        <div
          *ngFor="let selectedCompany of selectedCompanies"
          class="field-dialog__content__scroll__selected-companies__company"
        >
          <span class="field-dialog__content__scroll__selected-companies__company__text">
            {{ selectedCompany.name }}
          </span>
          <mat-icon
            (click)="toggleCompany(selectedCompany)"
            class="field-dialog__content__scroll__selected-companies__company__icon"
          >
            close
          </mat-icon>
        </div>
      </div>

      <span class="field-dialog__content__scroll__select-companies-message">
        <ng-container *ngIf="companies.length && !isLoading">
          {{ 'COMPANY_COMPARISON.DIALOG.SELECT_COMPANIES_MESSAGE' | translate }}
        </ng-container>
        <ng-container *ngIf="!companies.length && !isLoading">
          {{ 'COMPANY_COMPARISON.DIALOG.NOTHING_FOUND' | translate }}
        </ng-container>
        <ng-container *ngIf="isLoading">
          {{ 'COMPANY_COMPARISON.DIALOG.LOADING' | translate }}
        </ng-container>
      </span>

      <div class="field-dialog__content__scroll__companies">
        <ng-container *ngFor="let company of companies">
          <div
            (click)="toggleCompany(company)"
            class="field-dialog__content__scroll__companies__company"
            [ngClass]="{
              disabled:
                selectedCompaniesSelection.selected.length === selectedCompaniesLimit &&
                !selectedCompaniesSelection.isSelected(company.id)
            }"
          >
            <img
              *ngIf="company.avatarUrl"
              [src]="company.avatarUrl"
              (error)="company.avatarUrl = null"
              [alt]="'COMPANY_COMPARISON.DIALOG.COMPANY_LOGO' | translate"
              class="field-dialog__content__scroll__companies__company__logo"
            />
            <div
              *ngIf="!company.avatarUrl"
              class="field-dialog__content__scroll__companies__company__logo--default-logo"
            >
              <img
                src="assets/images/icons/mdi_office-building.svg"
                [alt]="'COMPANY_COMPARISON.DIALOG.COMPANY_LOGO' | translate"
                class="field-dialog__content__scroll__companies__company__logo--default-logo__image"
              />
            </div>
            <span class="field-dialog__content__scroll__companies__company__name">
              {{ company.name }}
            </span>
            <mat-checkbox
              *ngIf="
                selectedCompaniesSelection.selected.length !== selectedCompaniesLimit ||
                selectedCompaniesSelection.isSelected(company.id)
              "
              [checked]="selectedCompaniesSelection.isSelected(company.id)"
              [disabled]="
                selectedCompaniesSelection.selected.length === selectedCompaniesLimit &&
                !selectedCompaniesSelection.isSelected(company.id)
              "
              class="field-dialog__content__scroll__companies__company__checkbox"
            >
            </mat-checkbox>

            <ng-container
              *ngIf="
                selectedCompaniesSelection.selected.length === selectedCompaniesLimit &&
                !selectedCompaniesSelection.isSelected(company.id)
              "
            >
              <mat-icon class="field-dialog__content__scroll__block-choose">block</mat-icon>
            </ng-container>
          </div>
        </ng-container>

        <ng-container *ngIf="isLoading">
          <div
            *ngFor="let company of [1, 2, 3, 4, 5, 6, 7, 8, 9]"
            class="field-dialog__content__scroll__companies__company--skeleton"
          >
            <ngx-skeleton-loader
              appearance="circle"
              [theme]="{
                'border-radius': '5px',
                display: 'flex',
                margin: '0px',
                height: '72px',
                width: '72px'
              }"
            >
            </ngx-skeleton-loader>
            <ngx-skeleton-loader
              [theme]="{
                width: '200px',
                margin: '0px'
              }"
            >
            </ngx-skeleton-loader>
          </div>
        </ng-container>
      </div>
    </form>
  </div>

  <div class="field-dialog__footer">
    <button
      (click)="compare()"
      [ngClass]="{ disabled: !selectedCompaniesHasChanged || isLoading }"
      class="field-dialog__footer__button"
      [matTooltip]="'COMPANY_COMPARISON.DIALOG.COMPANIES_ALREADY_COMPARED' | translate"
      mat-raised-button
    >
      {{ 'COMPANY_COMPARISON.DIALOG.COMPARE' | translate }}
    </button>
  </div>
</div>
